import React, { Fragment, useContext, useCallback, useState, useEffect } from "react";
import Bulk from "../Bulk/Bulk";
import Basket from "../Basket/Basket";
import style from "./../Order.module.scss";
import { Container, Row, Col } from "reactstrap";
import { accountProps, customFetchAssetInfo, customFetchAccountInfo } from "./commons";
import { ProductType, Type, Mode, OrderStatus } from "../../../../utils/Order/Order";
import { Field, Symbol, RepoSymbol, Account, Numeric, PriceType, TimeForce } from "../Field/Field";
import { showToast, UserType } from "../../../../utils/Helper";
import { Dispatch } from "../store/store";
import { onChange, onAccountChange } from "../Order";
import QuantityHelper from "../Helper/QuantityHelper";
import Booktype from "../Field/Booktype";

const Repo = ({ maxDecimals, updatePrice, newSymbol, booktypes, platformRole, opsViewAccountName }) => {
  const { dispatch, state, services } = useContext(Dispatch);
  const { order, fields, ui } = state;
  const { editable, errors, readonly, hiddens } = fields;
  const [updateAccount, setUpdateAccount] = useState(false);

  const accountInfo = (props, updateOrderValues) =>
    customFetchAccountInfo(
      dispatch,
      services.account,
      {
        ...order,
        CurrentAccount: {
          ...order.CurrentAccount,
          ...props,
        },
      },
      updateOrderValues
    );

  const handleSymbolSelection = (v) => {
    if (v.OrderCurrencyId) {
      services.symbol
        .searchRepoSymbol({ iso: v.OrderCurrencySymbol })
        .then(({ response }) => {
          if (+response.AssetInformation.AssetId === 0) {
            showToast("Base repo asset not found for the selected currency", true);
            onChange(dispatch, {
              OrderCurrencyId: null,
              OrderCurrencySymbol: "",
            });
          } else {
            onChange(dispatch, {
              ...v,
              OrderSettlementCurrencyId: v.OrderCurrencyId,
              OrderSettlementCurrencySymbol: v.OrderCurrencySymbol,
              AssetId: response.AssetInformation.AssetId,
              AssetTicker: response.AssetInformation.Ticker,
              AssetDescription: response.securityAsset.Description,
              AssetSecurityProvider: response.securityAsset.Provider,
              AssetCanBeSelfCustodied: response.AssetInformation.AssetCanBeSelfCustodied,
              SubAssetClassDecimalPlaces: response.AssetInformation.SubAssetClassDecimalPlaces,
              AssetPriceIsDiscounted: false,
            });
          }
        })
        .catch((err) => console.error(err));
    }
  };

  const onChangeCollateral = (v) => {
    const newCollateral = {
      AssetId: v.AssetId,
      AssetTicker: v.AssetTicker,
      CollateralQuantity: 0,
    };
    const currency = v.AssetCurrency;
    const updRepo = {
      ...v,
      OrderCurrencyId: currency,
      OrderCurrencySymbol: currency,
      CurrentAccount: {
        ...order.CurrentAccount,
        Collateral: newCollateral.AssetId!=undefined?[newCollateral]: order.CurrentAccount.Collateral,
      }
    };
    

    if(newCollateral.AssetId!=undefined){
    onAccountChange(dispatch, { Collateral: [newCollateral] });
    }
    handleSymbolSelection(updRepo);
    setUpdateAccount((prev) => !prev);
  };

  const onChangeQuantity = (v) => {
    const newCollateral = {
      AssetId: order.CurrentAccount.Collateral[0].AssetId,
      AssetTicker: order.CurrentAccount.Collateral[0].AssetTicker,
      CollateralQuantity: v,
    };
    onAccountChange(dispatch, { Collateral: [newCollateral], Quantity: 1, OffsetQuantity: v });
  };

  const onChangeQuantityBuy = (v) => {
    onAccountChange(dispatch, { Quantity: 1, OffsetQuantity: v });
  };

  return (
    <div className={style.form}>
      <Container>
        <Row>
          <Col xs={12} lg={6}>
            <Field label={"Currency"} error={errors.OrderCurrencySymbol}>
              <RepoSymbol
                form={ProductType.FOREX}
                onChange={handleSymbolSelection}
                hideInfo
                placeholder="Currency"
                readonly={readonly.OrderCurrencySymbol}
                disabled={readonly.OrderCurrencySymbol || (order.offer && +order.offer.OfferId > 0)}
                invalid={!!errors.OrderCurrencySymbol}
                value={order.OrderCurrencySymbol || ""}
                attrId="OrderCurrencyId"
                attrTicker="OrderCurrencySymbol"
                {...services.symbol}
              />
            </Field>
            {order.OrderSide === "Sell" && (
              <Field label={"Collateral"} error={errors.OrderCurrencySymbol}>
                <Symbol
                  form={order.AssetClassForm}
                  onChange={onChangeCollateral}
                  placeholder={"Symbol"}
                  disabled={readonly.AssetTicker || (order.offer && +order.offer.OfferId > 0)}
                  invalid={!!errors.CollateralAssetTicker}
                  value={
                    order.CurrentAccount.Collateral ? order.CurrentAccount.Collateral[0].AssetTicker : ""
                  }
                  description={order.CurrentAccount.AssetDescription}
                  provider={order.CurrentAccount.AssetSecurityProvider}
                  assetid={order.CurrentAccount.AssetId}
                  attrId={"AssetId"}
                  attrTicker={"AssetTicker"}
                  attrDescription={"AssetDescription"}
                  attrProvider={"AssetSecurityProvider"}
                  attrCurrency={"AssetCurrency"}
                  {...services.symbol}
                  assetInfo={() => customFetchAssetInfo(dispatch, services.symbol, order)}
                  updatePrice={updatePrice}
                />
              </Field>
            )}
            <Field label="Volume" error={errors.OrderQuantity}>
              <Numeric
                value={order.CurrentAccount.OffsetQuantity}
                placeholder={"Volume"}
                onChange={order.OrderSide === "Sell" ? onChangeQuantity : onChangeQuantityBuy}
                invalid={!!errors.OffsetQuantity}
                dataTypeDecimalName="quantity"
              />
            </Field>
            <PriceType
              type={order.OrderType}
              form={ProductType.REPO}
              values={{
                limPrice: order.OrderPrice,
                stopPrice: order.OrderStopPrice,
              }}
              oldValues={{
                limPrice: order.HasOriginalOrReplacingData? order.OriginalOrReplacingData.OrderPrice : order.OrderPrice,
                stopPrice: order.HasOriginalOrReplacingData? order.OriginalOrReplacingData.OrderStopPrice : order.OrderStopPrice,
              }}
              editable={{
                limPrice: editable.OrderPrice && (order.OrderStatus === OrderStatus.ACKED),
                stopPrice: editable.OrderStopPrice && (order.OrderStatus === OrderStatus.ACKED),
              }}
              errors={{
                type: errors.OrderType,
                limPrice: errors.OrderPrice,
                stopPrice: errors.OrderStopPrice,
              }}
              readonly={{
                type: readonly.OrderType,
                limPrice: readonly.OrderPrice,
                stopPrice: readonly.OrderStopPrice,
              }}
              newSymbol={newSymbol}
              maxDecimals={maxDecimals}
              onChange={(v) => onChange(dispatch, v)}
            />
            <TimeForce
              date={order.OrderGTD}
              timeForce={order.OrderTimeInForce}
              errors={{
                date: errors.OrderGTD,
                timeForce: errors.OrderTimeInForce,
              }}
              readonly={{
                date: readonly.OrderGTD,
                timeForce: readonly.OrderTimeInForce,
              }}
              onChange={(v) => onChange(dispatch, v)}
            />
            {((ui.userRole === "Trader" && order.OrderSide === "Sell")|| (ui.userRole !== "Trader" && ui.mode !== Mode.EDIT && order.OrderSide === "Sell")) && <Booktype
              booktypes={booktypes}
              booktype={order.BookType}
              balancetype={order.CurrentAccount.BalanceType}
              errors={{
                BookType: errors.BookType,
                BalanceType: errors.BalanceType
              }}
              readonly={{
                BookType: readonly.BookType,
                BalanceType: errors.BalanceType
              }}
              onChange={(v) => onChange(dispatch, v)}
              onAccountChange={(v) => onAccountChange(dispatch, v)}
            />}
          </Col>

          {/* Right */}
          <Col xs={12} lg={6}>
            {/* ##### Account ###### */}
            {!ui.isBulk && !ui.isBasket && (
              <Account
                updateAccount={updateAccount}
                userType={ui.userRole}
                platformRole={platformRole}
                onChange={(v) => onAccountChange(dispatch, v)}
                onChangeOrder={(v) => onChange(dispatch, v)}
                balanceReady={!!order.OrderCurrencyId}
                dispatch={dispatch}
                {...services.account}
                accountInfo={accountInfo}
                {...accountProps({ order, readonly, errors })}
                hiddens={{
                  Quantity: true,
                  showClientPrice: true,
                  Markup: true,
                  ...hiddens,
                }}
                opsViewAccountName={opsViewAccountName}
              />
            )}

            {ui.isBulk && (
              <Bulk
                balanceReady={!!order.OrderCurrencyId}
                onChange={(v) => onAccountChange(dispatch, v)}
                accounts={order.Accounts || []}
                isReadOnly={ui.mode == Mode.READONLY}
                canModifyComposition={ui.mode == Mode.EDIT}
                readonly={readonly}
                error={errors.Accounts}
                account={order.CurrentAccount}
                {...services.account}
                accountInfo={accountInfo}
                hiddens={{
                  ...hiddens,
                }}
              />
            )}

            {ui.isBasket && (
              <Basket
                balanceReady={!!order.AssetId}
                onChange={(v) => onAccountChange(dispatch, v)}
                accounts={order.Accounts || []}
                isReadOnly={ui.mode == Mode.READONLY}
                canModifyComposition={ui.mode == Mode.EDIT}
                readonly={readonly}
                error={errors.Accounts}
                account={order.CurrentAccount}
                {...services.account}
                accountInfo={accountInfo}
                hiddens={{
                  ...hiddens,
                }}
              />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export const defaultValues = () => {
  return {
    OrderSide: "Buy",
    BookType: "Self"
  };
};

export const validations = (order, userType) => {
  const filteredBankAccounts = order.CurrentAccount.clientBankAccounts
  ? order.CurrentAccount.clientBankAccounts.filter(
      (account) => account.currencyISO === order.OrderCurrencySymbol
    )
  : [];

  const isMultiAccounts = order.OrderHasMultipleAccounts;

  return {
    OrderQuantity: { empty: !isMultiAccounts },
    OrderCurrencySymbol: { empty: true, autosuggestId: "OrderCurrencyId" },
    OrderTimeInForce: { empty: true },

    // The following properties are from an account.
    AccountName: {
      empty: true,
      accountLevel: true,
    },
    clientBankAccounts: {
      noBankAccountSelected: filteredBankAccounts && filteredBankAccounts.length > 0 && (order.CurrentAccount.clientBankAccount == null || order.CurrentAccount.clientBankAccount == "") && !order.CurrentAccount.useCashAccount,
    },
    HolderName: {
      empty: userType !== UserType.Trader,
      accountLevel: true,
    },
    Quantity: {
      empty: true,
      accountLevel: true,
    },
    Instruction: {
      empty: userType !== UserType.Trader,
      accountLevel: true,
    },
  };
};

export default Repo;
